export const gitInfo = { commitHash: "a02b759", version: "v2.0.0-58-ga02b759" };
